var _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCofre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 162,
    viewBox: "0 0 202 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.8904,
    y: 90.9901,
    width: 160.685,
    height: 70.3398,
    fill: "#F8DE43"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6047,
    y: 90.9901,
    width: 123.256,
    height: 53.5615,
    fill: "#FEFAEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8904 90.9901H183.575V65.4613C183.575 54.6125 174.78 45.8177 163.931 45.8177H42.5339C31.6851 45.8177 22.8904 54.6125 22.8904 65.4613V90.9901Z",
    fill: "#F8DE43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 123.256,
    height: 27.7487,
    transform: "matrix(1 0 0 -1 41.6047 73.5664)",
    fill: "#FEFAEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7131 45.8177L161.634 45.8177",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2747 60.0046L41.652 91.507H154.536L105.407 22.1267C102.032 33.3776 95.2811 56.1043 95.2811 57.0044C95.2811 57.9044 58.7783 19.3765 40.5269 0L41.652 46.5036L26.2758 42.3782L28.1509 65.63L11.2747 60.0046Z",
    fill: "#F62722"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0276 91.507L48.0273 85.8816L54.4028 87.0067L48.0273 60.3796L75.7795 91.507H85.1552L88.1554 79.1311L106.907 85.8816L115.533 67.5052L135.784 91.507H85.1552H75.7795H51.0276Z",
    fill: "#F8DE43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0234 90.9901L178.412 90.9901",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.072 91.3027C129.23 90.3927 129.313 89.4566 129.313 88.5012C129.313 79.5402 122.048 72.2759 113.087 72.2759C108.428 72.2759 104.228 74.2394 101.269 77.3841C98.3098 74.2395 94.1095 72.2759 89.4507 72.2759C80.4897 72.2759 73.2253 79.5403 73.2253 88.5013C73.2253 89.4128 73.3005 90.3068 73.445 91.1773C73.4319 91.2191 73.4252 91.2619 73.4252 91.3056C73.4251 108.678 101.068 126.16 101.068 126.16C101.068 126.16 129.112 108.776 129.112 91.3056C129.112 91.3056 129.099 91.3046 129.072 91.3027Z",
    fill: "#FFC0D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.815 97.353C104.868 96.6348 106.34 94.6807 106.34 92.3826C106.34 89.4751 103.983 87.1182 101.076 87.1182C98.1685 87.1182 95.8115 89.4751 95.8115 92.3826C95.8115 94.7883 97.4251 96.8171 99.6291 97.4457L96.8642 107.123H106.603L102.815 97.353Z",
    fill: "#F62722"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.415 49.0443L200.999 36.4606",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5823 49.0443L0.998542 36.4606",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M191.319 54.8522L200.999 53.5615",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6785 54.8522L0.998672 53.5615",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCofre);
export default __webpack_public_path__ + "static/media/cofre.0b0fa6841677fa45f3c2f7a93bd36d4d.svg";
export { ForwardRef as ReactComponent };